var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"la-ball-clip-rotate-pulse"},[_c('div'),_c('div')]):_c('icon',{attrs:{"icon":_vm.icon}})}
var staticRenderFns = []

export { render, staticRenderFns }